import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const FoldMenuModal = styled.div`
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  background-color: #fff;
  max-height: calc(-50px + 100vh);
  height: 100%;
  border-radius: 20px 20px 0 0;
  overflow: hidden;

  .content {
    overflow-y: auto;
  }

  .item-box {
    ${mixin.flex({
      wrap: 'wrap',
      align: 'flex-start',
      justify: 'flex-start',
    })}
    align-content: flex-start;
    padding: 12px 20px 32px;
    gap: 6px;
    height: 205px;
    overflow-y: auto;
  }

  .area-click {
    height: 36px;
  }

  &.is-old-app-iphonex {
    padding-bottom: 34px;
  }

  @media ${({ theme }) => theme.media.smMax} {
    max-height: calc(-${mixin.pxToVw('50')} + 100vh);
    border-radius: ${mixin.pxToVw('20 20 0 0')};

    .item-box {
      padding: ${mixin.pxToVw('12 20 32')};
      gap: ${mixin.pxToVw('6')};
      height: ${mixin.pxToVw('205')};
    }

    .area-click {
      height: ${mixin.pxToVw('36')};
    }
  }
`;
